import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineMediumAlt = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="160px"
        height="5px"
        viewBox="0 0 160 5"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M158.3,1c-0.2-0.1-0.4-0.3-0.4-0.3c-0.3,0.1-0.4,0-0.5-0.2c-0.2-0.5-0.8-0.1-1.2-0.3c-0.5,0.6-1,0-1.5,0
        		c-0.3,0.1-0.7,0.3-0.9,0.2c-0.7-0.3-1.5-0.2-2.3-0.1c-0.5,0-0.7,0-1.1-0.4c-0.1,0.3-0.2,0.6-0.3,0.9c-0.9-0.7-1.9-0.7-2.9-0.4
        		c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2,0.1-0.4,0.2-0.5,0.3c-0.2,0.1-0.3,0.1-0.6,0.3c-0.1-0.2-0.2-0.3-0.2-0.3c-0.6,0.1-1.2,0.3-1.6,0.2
        		c-0.8-0.2-1.6-0.1-2.4,0c-0.8,0.1-1.7,0.3-2.3-0.2c-0.4,0.1-0.7,0.2-1,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0.3-0.5,0.5-1,0.4
        		c-0.3-0.1-0.7-0.2-1-0.3c-0.5-0.1-1-0.1-1.2,0.3c-0.4-0.2-0.8-0.4-1.2-0.5c-0.3,0.2-0.4,0.4-0.7,0.6c-0.1-0.2-0.2-0.4-0.3-0.6
        		c-0.5,0-0.9-0.1-0.9,0.4c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0.1-0.7,0.1c-0.6-0.2-1.1-0.4-1.7,0c0,0-0.2,0-0.2,0
        		c-0.4-0.2-0.9-0.1-1.3-0.1c-0.2,0-0.4-0.2-0.6-0.3c-0.7,0.3-0.7,0.3-2.2,0c0,0.2,0,0.3-0.1,0.5c-1.1-0.2-2.2-0.5-3.3-0.1
        		c-0.8-0.3-1.8,0.3-2.4-0.3c-0.4,0.1-0.7,0.2-1,0.3c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2,0.2-0.3,0.4-0.3,0.4c-0.6-0.1-1.1-0.2-1.6-0.1
        		c-0.5,0.1-1,0.1-1.5-0.2c-0.1-0.1-0.3-0.1-0.5-0.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.6-0.1-1.1-0.3-1.6-0.4c-0.1,0-0.1,0-0.2,0.1
        		c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1-0.1-0.2-0.2-0.3-0.4c-0.4,0.1-0.7,0.2-1,0.2c-0.2,0-0.4-0.2-0.6-0.3c-0.4,0.1-0.8,0.3-1.1,0.3
        		c-1.4-0.1-2.8,0-4.1-0.2c-0.2,0-0.5-0.1-0.6,0c-0.9,0.6-1.8-0.1-2.7,0.1c-0.7-0.6-1-0.1-1.5,0.3c-0.5-0.5-1.1-0.7-1.7-0.2
        		c-0.1,0.1-0.3,0.1-0.4,0.1c-0.7-0.2-1.2,0.1-1.7,0.4c-0.1-0.2-0.3-0.4-0.3-0.4c-0.8,0.2-1.6-0.1-2.4-0.1c-1,0-2,0.4-3.1,0.1
        		c-0.6,0.3-1.2,0-1.8-0.1c-0.2,0-0.6-0.1-0.6-0.1c-0.6,0.6-1,0.1-1.5,0C83,0.7,82.9,0.7,82.8,0c-0.3,0.3-0.5,0.5-0.7,0.8
        		c-0.6-0.6-1.5,0.1-2.2-0.4c-0.1,0.2-0.3,0.4-0.4,0.7c-0.5-0.3-0.9-0.5-1.4-0.8c-0.8,0.5-1.6,0-2.4,0.1c0,0.1,0,0.2,0,0.3
        		c-0.7,0.1-1.3,0-1.7-0.5c-0.5,0.1-0.7,0.7-1.3,0.4c-0.8-0.4-0.8,0.1-1.2,0.4c-0.4-0.3-0.7-0.9-1.4-0.2c-0.2-0.2-0.4-0.4-0.6-0.6
        		c-0.4,0.2-0.7,0.3-1,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2,0.2-0.4,0.3-0.8,0.6
        		c-0.1-0.2-0.3-0.4-0.4-0.6c-0.7,0.5-1.5,0.6-2.1,0.4c-1-0.3-1.8-0.2-2.6,0c-0.4-0.1-0.8-0.1-1.2-0.2c-0.5-0.2-0.6,0.4-1.1,0.2
        		c-0.2-0.2-0.4-0.3-0.6-0.5c-0.4,0.2-0.7,0.4-1,0.6c-0.5-0.2-0.9-0.3-1.4-0.5c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0-0.5-0.1-0.7-0.1
        		c-0.3,0-0.6,0-0.8-0.1c-0.5-0.1-1.1-0.4-1.5,0.2c-0.6-0.3-1.4,0.1-2-0.3c-0.2-0.2-0.5-0.2-0.6,0.1c-0.1,0.3-0.3,0.2-0.6,0.3
        		c-0.2,0-0.3,0.2-0.5,0.3C48.2,1,48.1,0.9,48,0.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.4,0-0.8-0.2-1.2-0.2
        		c-0.7-0.1-1,0.1-1.3,0.7c0,0-0.2,0.1-0.3,0.1c0-0.3,0-0.5,0.1-0.9c-0.4,0.1-0.6,0.1-0.9,0.2c-0.2,0-0.5,0.1-0.6,0.1
        		c-0.2-0.1-0.2-0.3-0.4-0.6c-0.4,0.2-0.7,0.4-1.1,0.6c-0.3,0-0.8-0.1-1.2-0.2c-1-0.2-1-0.3-1.5,0.3c-0.3-0.4-1-0.5-1.4-0.3
        		c-0.4,0.1-0.8,0.1-1.2,0c-0.5,0-1.1-0.1-1.6,0.1c-0.3,0.1-0.6,0-0.9-0.1c-0.5-0.2-0.8-0.1-0.9,0.3c-1.1,0.3-1.9-0.4-2.9-0.5
        		c0.1,0.2,0.2,0.3,0.2,0.5c-0.8,0.2-1.2-0.1-1.5-0.6c-0.5,0.3-0.7,0.3-1.4,0.2c-0.1,0-0.2,0-0.3,0c-0.4,0.4-0.8,0.2-1.2,0
        		c-0.2-0.1-0.7-0.1-0.7,0c-0.1,0.4-0.7,0.2-0.8,0.2c-0.5,0.4-0.7-0.2-1.2-0.1c-0.4,0.1-0.8,0.3-1.3,0c-0.3-0.2-1,0-1.4,0
        		c-0.6,0.1-1-0.1-1.6-0.4c-0.1,0.2-0.3,0.3-0.4,0.4c-0.4-0.2-0.7-0.4-1-0.5c-0.4,0.7-1,0.6-1.7,0.3c-0.3-0.1-0.6-0.1-1-0.2
        		c0.1,0.2,0.2,0.4,0.3,0.6c-0.5-0.1-1,0-1.2-0.2c-0.5-0.5-0.9-0.3-1.5,0c-0.5,0.2-1.3,0.2-1.9,0.2c-0.3,0-0.6-0.3-0.9-0.5
        		C8.7,0.8,8.3,1,7.9,0.8c-0.7-0.2-2-0.2-2.6-0.1c-0.5,0.1-0.9,0-1-0.4c0-0.1-0.1-0.1-0.3-0.2c0,0.2,0,0.3,0,0.4
        		C3.1,0.6,2.3,0.5,1.7,0.4C1.3,0.7,1,0.9,0.8,1C0.5,1.3,0.1,1.5,0,1.7l1,0.4c0.6,0.1,1.4,0.1,2.3,0.2c0-0.2,0-0.3,0-0.5
        		C3.4,2,3.5,2,3.6,2.1c0.1,0.4,0.5,0.5,1,0.4c0.3-0.1,0.7-0.1,1.1-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.5,0,1.1,0.1,1.4,0.2
        		c0.4,0.1,0.9,0,1.5-0.5c0.3,0.2,0.6,0.5,1,0.5c0.7,0,1.4,0,2-0.2c0.6-0.3,1-0.5,1.5,0c0.2,0.2,0.7,0.1,1.3,0.2
        		c-0.1-0.2-0.2-0.4-0.3-0.6c0.4,0.1,0.7,0.1,1,0.2c0.7,0.2,1.4,0.3,1.8-0.4c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0
        		c0-0.1,0.1-0.1,0.3-0.2c0,0.2,0.1,0.3,0.1,0.4c0,0,0,0,0,0c0.2,0.1,0.4,0.2,0.6,0.3c0.1-0.1,0.2-0.3,0.4-0.5c0.6,0.2,1,0.5,1.6,0.4
        		c0.5-0.1,1.2-0.2,1.5,0c0.5,0.3,1,0.1,1.4,0.1c0.4-0.1,0.7,0.5,1.2,0.1c0.1-0.1,0.7,0.2,0.8-0.3c0,0,0.1,0,0.2,0C25,2,25,2,25,1.9
        		c0-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.2,0.2c0,0-0.1,0.1-0.1,0.2c0.2,0,0.4,0,0.5,0.1c0.4,0.2,0.8,0.4,1.3,0c0,0,0.2,0,0.3,0
        		c0.7,0.1,0.9,0,1.4-0.2c0.3,0.5,0.7,0.8,1.6,0.6C30.1,2.3,30.1,2.2,30,2c1.1,0.1,1.9,0.8,3,0.5c0.1-0.4,0.4-0.5,0.9-0.3
        		c0.3,0.1,0.6,0.2,1,0.1c0.5-0.2,1.1-0.1,1.6-0.1c0.4,0,0.8,0.1,1.2,0c0.5-0.2,1.1-0.1,1.5,0.4C39.8,2,39.8,2,40.8,2.3
        		c0.4,0.1,0.9,0.1,1.2,0.2c0.4-0.2,0.7-0.4,1.1-0.7c0.2,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.4,0,0.6-0.1c0.3,0,0.5-0.1,0.9-0.2
        		c0,0.3,0,0.6-0.1,0.9c0.2,0,0.3-0.1,0.3-0.1c0.3-0.6,0.6-0.8,1.3-0.7c0.4,0,0.8,0.2,1.3,0.2c0.2,0,0.4-0.1,0.6-0.2
        		c0,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.4,0.2c0.2-0.1,0.3-0.3,0.5-0.3c0.3,0,0.5,0,0.7-0.3c0.1-0.3,0.4-0.3,0.7-0.1
        		c0.6,0.4,1.4,0,2,0.3c0.4-0.6,1-0.3,1.6-0.2c0.3,0,0.6,0,0.8,0.1c0.2,0,0.5,0,0.7,0.1c0.1-0.1,0.3-0.3,0.5-0.4
        		c0.5,0.2,1,0.3,1.4,0.5c0.3-0.2,0.7-0.4,1.1-0.6c0.2,0.2,0.4,0.3,0.6,0.5c0.5,0.2,0.6-0.4,1.1-0.2c0.3,0.1,0.8,0.1,1.2,0.2
        		c0.8-0.2,1.7-0.4,2.7-0.1c0.7,0.2,1.4,0.1,2.2-0.4c0.1,0.2,0.3,0.4,0.4,0.6c0.4-0.3,0.6-0.4,0.8-0.6c0.2,0.2,0.3,0.3,0.4,0.5
        		c0.4-0.2,0.8-0.3,1.3-0.5C70,2,70.1,2.1,70.2,2.2c0.3-0.1,0.6-0.2,1-0.4c0.2,0.2,0.3,0.4,0.6,0.6c0,0,0,0,0,0
        		c-0.1-0.2-0.1-0.4,0.1-0.7c0.1,0.2,0.2,0.3,0.3,0.5c0.5-0.2,0.7,0.3,1,0.5c0.3-0.3,0.4-0.8,1.2-0.4C75,2.6,75.3,2,75.8,1.9
        		c0.4,0.5,1,0.6,1.8,0.5c0-0.1,0-0.2,0-0.4c0.8-0.2,1.7,0.4,2.5-0.1c0.5,0.3,0.9,0.5,1.4,0.8c0.1-0.2,0.3-0.4,0.4-0.7
        		c0.7,0.6,1.6-0.1,2.2,0.5c0.3-0.3,0.5-0.5,0.8-0.8c0.1,0.7,0.2,0.8,1.2,0.4c0.5,0.2,1,0.7,1.5,0c0-0.1,0.4,0,0.7,0.1
        		c0.5,0.1,0.9,0.3,1.4,0.2c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c1.1,0.3,2.1-0.1,3.2-0.1c0.8,0,1.6,0.2,2.5,0.1
        		c0,0,0.2,0.2,0.3,0.4c0.5-0.4,1-0.7,1.8-0.5c0.1,0,0.4,0,0.5-0.1c0.7-0.4,1.3-0.2,1.8,0.3c0.5-0.3,0.8-0.9,1.5-0.3
        		c0.9-0.2,1.9,0.5,2.8-0.1c0.1-0.1,0.4,0,0.6,0c1.4,0.3,2.9,0.1,4.3,0.2c0.3,0,0.7-0.2,1.1-0.3c0.1,0.1,0.3,0.3,0.6,0.3
        		c0.3,0,0.6-0.1,1-0.2c0.1,0.1,0.2,0.3,0.3,0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.1,0,0.2,0,0.2-0.1c0.5,0.1,1,0.3,1.6,0.4
        		c0.1-0.3,0.1-0.4,0.2-0.6c0.2,0.1,0.4,0.1,0.6,0.2c0.5,0.3,1,0.2,1.5,0.2c0.5-0.1,1,0.1,1.6,0.1c0,0,0.2-0.2,0.3-0.4
        		c0.2,0.2,0.4,0.3,0.6,0.5c0.1,0,0.3-0.1,0.4-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0.2,0,0.4,0,0.6,0.1c0.1,0,0.2,0,0.3-0.1
        		c0,0,0.1,0.1,0.1,0.1c-0.2-0.3,0-0.4,0.5-0.6c0,0.2,0.1,0.4,0.1,0.6c-0.2,0-0.4,0-0.6,0c0.6,0.4,1.5-0.1,2.3,0.2
        		c1.1-0.4,2.3-0.1,3.4,0.1c0-0.2,0.1-0.3,0.1-0.5c1.6,0.3,1.6,0.3,2.3,0c0.2,0.1,0.4,0.2,0.6,0.3c0.4,0.1,0.9-0.1,1.4,0.1
        		c0.1,0,0.2,0,0.2,0c0.6-0.4,1.2-0.1,1.8,0c0.2,0.1,0.5,0,0.7-0.1c0.3,0,0.6,0,1,0c-0.1-0.5,0.4-0.4,0.9-0.4
        		c0.1,0.2,0.2,0.3,0.3,0.6c0.3-0.2,0.5-0.4,0.7-0.6c0.4,0.2,0.8,0.4,1.2,0.6c0.2-0.5,0.7-0.4,1.2-0.4c0.4,0.1,0.7,0.2,1,0.3
        		c0.5,0.1,0.9,0,1.1-0.4c0.3,0.1,0.6,0.2,1,0.2c0.3,0,0.6-0.1,1-0.2c0.6,0.6,1.5,0.3,2.3,0.2c0.8-0.1,1.6-0.2,2.5,0
        		c0.4,0.1,1-0.1,1.6-0.2c0,0,0.1,0.2,0.2,0.4c0.3-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.3-0.2,0.6-0.3c0.2,0.1,0.4,0.3,0.6,0.4
        		c1.1-0.4,2.1-0.4,3,0.4c0.1-0.4,0.2-0.6,0.3-1c0.3,0.4,0.6,0.5,1.1,0.4c0.8-0.1,1.6-0.2,2.3,0.1c0.2,0.1,0.6-0.1,1-0.2
        		c0.2,0,0.4,0.1,0.6,0.1c0-0.1,0-0.2,0-0.2c0-0.4-0.2-0.7-0.8-0.8c-0.2-0.1-0.4-0.2-0.6-0.2C158.5,0.8,158.3,1.1,158.3,1z M6.4,1.9
        		C5.9,2,5.6,1.9,5.8,1.4C6.1,1.6,6.2,1.8,6.4,1.9z M9.3,1.2C9.2,1.2,9.1,1.1,9,1.1C9.1,1,9.2,1,9.2,0.9C9.4,1,9.4,1,9.5,1.1
        		C9.4,1.1,9.4,1.2,9.3,1.2z M13.1,1.9c0,0-0.1,0-0.2,0c0-0.1,0-0.2-0.1-0.3c0.1,0,0.2,0,0.3,0C13.2,1.6,13.2,1.7,13.1,1.9z
        		 M15.9,1.7c-0.2-0.4-0.2-0.4,0.5-0.4C16.2,1.4,16.1,1.5,15.9,1.7z M26.8,2.2c0,0.1-0.1,0.1-0.2,0.1c0-0.1-0.1-0.1-0.1-0.2
        		c0-0.1,0.1-0.1,0.2-0.2C26.7,2.1,26.8,2.2,26.8,2.2z M28.2,1.2c-0.1,0-0.2-0.1-0.3-0.2C28,1,28,0.9,28.2,0.8
        		c0.1,0.1,0.2,0.2,0.3,0.2C28.3,1.1,28.2,1.2,28.2,1.2z M33.3,1.9C33.2,2,33.1,2,33,2.1C33,2.1,32.9,2,32.8,1.9
        		c0-0.1,0.1-0.1,0.1-0.2C33.1,1.8,33.1,1.8,33.3,1.9z M71.9,1.7c-0.4,0.1-0.5,0-0.5-0.5C71.7,1.5,71.8,1.6,71.9,1.7z M91.8,1.5
        		C92,1.2,92.2,1,92.7,1.1C92.5,1.4,92.4,1.7,91.8,1.5z"
            />
            <path fill={color} d="M73.6,3.5c-0.1-0.1-0.2-0.2-0.5-0.5C73.1,3.5,73.2,3.6,73.6,3.5z" />
            <path fill={color} d="M94.3,3.2c0.6,0.2,0.7-0.1,0.9-0.4C94.6,2.7,94.4,2.9,94.3,3.2z" />
            <path
                fill={color}
                d="M17,3.9c0.1,0,0.2,0,0.2-0.1c0-0.1,0-0.2-0.1-0.4c-0.2,0.1-0.3,0.2-0.3,0.2C16.9,3.7,17,3.8,17,3.9z"
            />
            <path fill={color} d="M15.7,3.4C15.8,3.3,16,3.1,16.1,3C15.5,3,15.5,3,15.7,3.4z" />
            <path
                fill={color}
                d="M12.6,3.6c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0-0.3,0C12.5,3.4,12.6,3.5,12.6,3.6z"
            />
            <path
                fill={color}
                d="M8.5,2.8c0.1,0,0.2,0.1,0.3,0.1C8.9,2.9,9,2.8,9,2.8C9,2.7,8.9,2.7,8.7,2.6C8.7,2.7,8.6,2.7,8.5,2.8z"
            />
            <path
                fill={color}
                d="M28.1,2.7c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.1-0.3-0.2
        		C28.2,2.6,28.1,2.6,28.1,2.7z"
            />
            <path
                fill={color}
                d="M33.2,3.7c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
        		C33.3,3.5,33.2,3.6,33.2,3.7z"
            />
            <path
                fill={color}
                d="M38.9,4.8C38.9,4.9,39,5,39.1,5c0.1,0,0.2-0.1,0.2-0.1c0-0.1-0.1-0.1-0.2-0.4C39,4.7,38.9,4.8,38.9,4.8z"
            />
            <path
                fill={color}
                d="M26.7,4.1c0.1,0,0.2-0.1,0.2-0.1c0-0.1-0.1-0.1-0.1-0.3c-0.1,0.1-0.2,0.2-0.2,0.2C26.5,4,26.6,4,26.7,4.1z"
            />
            <path
                fill={color}
                d="M25.4,3.7c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.2C25.3,3.8,25.4,3.7,25.4,3.7z
        		"
            />
            <path
                fill={color}
                d="M28,5c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2C27.9,4.9,27.9,5,28,5z"
            />
        </g>
    </svg>
);

LineMediumAlt.propTypes = propTypes;
LineMediumAlt.defaultProps = defaultProps;

export default LineMediumAlt;
